export default {
    methods: {
        normalizeWeight(raw) {
            const weight = raw || {}
            return {
                from: this.normalizeNumber(weight.from),
                to: this.normalizeNumber(weight.to),
                fromOperator: this.normalizeOperator(weight.fromOperator, 'GTE'),
                toOperator: this.normalizeOperator(weight.toOperator, 'LTE'),
                unit: weight.unit || '% (w/w)',
            }
        },
        applyWeightChange(target, value) {
            const next = this.normalizeWeight(value)
            const text = this.formatWeightRangeWithOperators(
                next.from,
                next.to,
                next.fromOperator,
                next.toOperator,
                next.unit,
            )
            return {
                weight: next,
                weightText: text,
            }
        },
        buildWeightPayload(weight) {
            const normalized = this.normalizeWeight(weight)
            return {
                from: normalized.from,
                to: normalized.to,
                fromOperator: normalized.fromOperator,
                toOperator: normalized.toOperator,
                unit: normalized.unit,
            }
        },
    },
}
